<template>
  <ScModal
    :show="show"
    :class="'user-modal'"
    @close="close"
  >
    <form
      v-if="show"
      @submit.prevent="onSubmit"
      novalidate
    >
      <div class="modal-header">
        <h5 class="modal-title">
          {{ $t(`authorization.modal.changePassword`) }}
        </h5>
        <button
          type="button"
          class="close"
          @click="close"
        >
          <span>&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div
          class="form-input"
          v-for="(input, index) in modalData"
          :key="'form-input-'+index"
        >
          <ScLabel>
            {{ $t(`authorization.inputs.label.${input.key}`) }}
          </ScLabel>
          <ScPassword
            :class="{invalid: errors.has(input.key)}"
            :ref="input.key"
            v-validate="input.validation"
            :data-vv-name="input.key"
            v-model="input.value"
            :placeholder="$t(`authorization.inputs.placeholder.${input.key}`)"
          />
        </div>
        <ValidationRules
          :validation-results="errors.items"
          :initial="isInitial"
        />
      </div>
      <div class="modal-footer">
        <ScButton
          type="submit"
          variant="secondary"
          class="form-button"
        >
          {{ $t(`authorization.modal.changePasswordButton`) }}
        </ScButton>
      </div>
    </form>
  </ScModal>
</template>

<script>

import ScButton from '@trendyol/sc-ui-kit/ScButton';
import ScLabel from '@trendyol/sc-ui-kit/ScLabel';
import ScPassword from '@trendyol/sc-ui-kit/ScPassword';
import ScModal from '@trendyol/sc-ui-kit/ScModal';
import ValidationRules from '@/components/Shared/ValidationRules';
export default {
  name: 'ChangePasswordModal',
  components: { ScPassword, ScButton, ScLabel, ScModal, ValidationRules },
  data () {
    return {
      isInitial: true,
      modalData: [
        {
          key: 'currentPassword',
          value: '',
          validation: {
            required: true,
            noSpecialCharacter: true,
            noNumber: true,
            noUpperAndLowerCase: true,
            min: true,
          },
        },
        {
          key: 'newPassword',
          value: '',
          validation: {
            required: true,
            noSpecialCharacter: true,
            noNumber: true,
            noUpperAndLowerCase: true,
            min: true,
          },
        },
        {
          key: 'passwordConfirmation',
          value: '',
          validation: {
            required: true,
            confirmed: 'newPassword',
          },
        },
      ],
    };
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show () {
      this.isInitial = true;
      this.modalData.map((val, index) => {
        this.$set(this.modalData[index], 'value', '');
      });
    },
  },
  methods: {
    close () {
      this.errors.clear();
      this.$emit('close');
    },
    onSubmit () {
      return this.$validator.validate().then(valid => {
        this.isInitial = false;
        if (!valid) {
          return false;
        }
        this.$emit('submit', { data: this.modalData, userId: this.data.id });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .user-modal{
    & .modal-header{
      padding: 35px 30px 25px 30px;
      & .modal-title{
        font-size: 20px !important;
      }
    }
    & .modal-body{
      padding: 0 30px;
      & .form-input {
        &:not(:first-child) {
          margin-top: 20px;
        }
        &::v-deep input{
          height: 40px;
        }
        & .invalid{
          &::v-deep input{
            border-color: #dc3545;
          }
          &::v-deep .eye-icon:before{
            color: #dc3545;
          }
        }
      }
      & .validation-rules {
        margin-top: 30px;
        .header {
          font-size: 14px;
          font-weight: 500;
          color: #273142;
          margin-bottom: 13px;
        }
        .rules-list {
          padding: 0 !important;
          margin: 0 !important;
          li {
            list-style-type: none;
            font-size: 12px;
            color: #273142;
            &:not(:last-child) {
              margin-bottom: 13px;
            }

            img, span {
              margin-right: 8px;
            }
          }
        }
      }
    }

    & .modal-footer{
      padding: 30px;
      border-top: none;
      & .form-button {
        width: 100%;
        height: 40px;
      }
    }
  }
</style>
